import React, { Fragment } from 'react';
import { ModalPanel, CloseModalButton } from './index';

const FullscreenModalInner = ({
  classModifier,
  id,
  children,
  showCloseModalText,
  ...props
}) => {
  return (
    <div className={`${classModifier}__modal-container`}>
      <div className={`${classModifier}__modal-panel`}>
        <div className={`${classModifier}__modal-panel__content`}>
          <CloseModalButton id={id} className={`${classModifier}__modal-close`}>
            <span className={showCloseModalText ? classModifier + '__modal-close__text' : "show-for-sr"}>Stäng</span>
          </CloseModalButton>
          {React.cloneElement(children, { ...props })}
        </div>
      </div>
    </div>
  );
};

const FullscreenModal = ({
  classModifier,
  id,
  children,
  closeModal,
  showCloseModalText = false,
  hideWithCss = false,
}) => {
  return (
    <Fragment>
      <ModalPanel hideWithCss={hideWithCss} whenActive={id}>
        <FullscreenModalInner
          classModifier={classModifier}
          closeModal={closeModal}
          showCloseModalText={showCloseModalText}
        >
          {children}
        </FullscreenModalInner>
      </ModalPanel>
    </Fragment>
  );
};

export default FullscreenModal;
